/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A simplified version of the ArticleSerializer that is tailored to provide
 * all information that are important for a GuestRequest part.
 * 
 * Note:
 *     This serializer is meant to be used as a read-only serializer. To deserialize
 *     an incoming Part POST-request, use the PartCreationSerializer.
 * @export
 * @interface APIPartRequest
 */
export interface APIPartRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPartRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartRequest
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartRequest
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartRequest
     */
    qualityClass?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPartRequest
     */
    isBomBase?: boolean;
}

/**
 * Check if a given object implements the APIPartRequest interface.
 */
export function instanceOfAPIPartRequest(value: object): value is APIPartRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function APIPartRequestFromJSON(json: any): APIPartRequest {
    return APIPartRequestFromJSONTyped(json, false);
}

export function APIPartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
    };
}

export function APIPartRequestToJSON(value?: APIPartRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'quality_class': value['qualityClass'],
        'is_bom_base': value['isBomBase'],
    };
}

